import React from 'react'
import {Box, Typography, Tooltip} from '@mui/material'
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined'
import {formatCurrency, formatNumber} from '../../helpers/UtilityHelper'
import {FONT, WEIGHT} from '../../styles/foundation/typography'
import {BORDER, WHITE, SUBTLE, PRIMARY_BLUE, SUCCESS, ERROR, WARNING} from '../../styles/foundation/colors'
import {SHADOW} from '../../styles/foundation/effects'

const KPI_CONFIG = [
  {key: 'totalShipments', label: 'Total Shipments', color: PRIMARY_BLUE, format: (v) => formatNumber(v),
    info: 'Every shipment placed in the selected date range and vertical, regardless of status.'},
  {key: 'totalRevenue', label: 'Sales Revenue', color: SUCCESS, format: (v) => formatCurrency(v, true),
    info: 'Invoice value of shipments that are NOT RTO, Cancelled, or Lost — the revenue from orders that actually went through. This is different from the "Total Revenue" shown further down in Revenue vs Shipping Cost, which includes RTO/Cancelled/Lost shipments too.'},
  {key: 'totalShipmentCost', label: 'Shipping Cost', color: WARNING, format: (v) => formatCurrency(v, true),
    info: 'Courier freight cost across all shipments except Cancelled ones — RTO and Lost shipments are included here, since freight was still spent moving them.'},
  {key: 'totalRTOCost', label: 'RTO Cost', color: ERROR, format: (v) => formatCurrency(Math.round(v || 0), true),
    info: 'Courier freight cost for shipments that came back as RTO only.'},
  {key: 'totalLostShipmentsCost', label: 'Lost Cost', color: SUBTLE, format: (v) => formatCurrency(v),
    info: 'Invoice value of shipments marked Lost.'},
]

const RevenueSummary = ({data, flow = 'ALL'}) => {
  const isReverse = flow === 'REVERSE';
  const config = (isReverse
    ? KPI_CONFIG.filter((c) => c.key !== 'totalRTOCost').map((c) =>
        c.key === 'totalRevenue' ? {...c, label: 'Invoice Value', info: 'Total invoice value of reverse shipments in this period.'} : c)
    : KPI_CONFIG);
  return (
  <Box sx={{
    display: 'grid', gridTemplateColumns: {xs: 'repeat(2,1fr)', sm: 'repeat(3,1fr)', md: `repeat(${config.length},1fr)`},
    bgcolor: WHITE, border: `1px solid ${BORDER}`, borderRadius: '10px', overflow: 'hidden',
    boxShadow: SHADOW.card, mb: '20px',
  }}>
    {config.map(({key, label, color, format, info}) => (
      <Box key={key} sx={{p: 1.75, borderRight: `1px solid ${BORDER}`, borderBottom: `1px solid ${BORDER}`}}>
        <Box sx={{display: 'flex', alignItems: 'center', gap: 0.5}}>
          <Box sx={{width: 7, height: 7, borderRadius: '2px', bgcolor: color, flex: 'none'}} />
          <Typography sx={{fontFamily: FONT, fontSize: '9.5px', fontWeight: WEIGHT.extra, letterSpacing: '0.05em', textTransform: 'uppercase', color: SUBTLE}}>{label}</Typography>
          <Tooltip title={info} arrow placement='top' componentsProps={{tooltip: {sx: {fontSize: 11, fontWeight: 400, lineHeight: 1.45, maxWidth: 280, textTransform: 'none', letterSpacing: 0, p: '8px 10px'}}}}>
            <InfoOutlinedIcon sx={{fontSize: 11, color: SUBTLE, opacity: 0.7, cursor: 'help', flex: 'none', '&:hover': {opacity: 1}}} />
          </Tooltip>
        </Box>
        <Typography sx={{fontFamily: FONT, fontSize: '22px', fontWeight: WEIGHT.extra, color, lineHeight: 1, fontVariantNumeric: 'tabular-nums', mt: 0.75}}>
          {format(data?.[key])}
        </Typography>
      </Box>
    ))}
  </Box>
  )
}

export default RevenueSummary
